import { useLocation } from "react-router-dom";
import Fetch from "../Fetch";
import StorageList from "./StorageList";
import { URL, TYPE, ACTION } from "../URL";
import { get_sort_flags } from "../util";

export default function FetchStorageList() {
    const flags = get_sort_flags(useLocation());
    return (
        <Fetch
            url={new URL(ACTION.LIST, TYPE.STORAGE, 0, flags)}
            renderSuccess={(data) => <StorageList data={data.data} />}
        />
    );
}
